import type { FC } from 'react';
import React from 'react';
import { addDDError } from '@wwe-portal/web/libs/analytics/datadog';

import { OfferCardTypeEnum } from '@wwe-portal/entities/offer.type';
import type { OfferCardProps } from '../type';

import { OfferSingle1Card } from './offer-single1';
import { OfferSingle2Card } from './offer-single2';
import { OfferSingle3Card } from './offer-single3';

const Cards: Record<OfferCardTypeEnum, React.FC<OfferCardProps>> = {
  [OfferCardTypeEnum.SINGLE3]: OfferSingle3Card,
  [OfferCardTypeEnum.SINGLE2]: OfferSingle2Card,
  [OfferCardTypeEnum.SINGLE1]: OfferSingle1Card,
};

export const OfferCard: FC<OfferCardProps> = (props: OfferCardProps) => {
  if (!props.type) return null;
  if (!Object.values(OfferCardTypeEnum).includes(props.type)) {
    const error = `Unsupported OfferCard type: ${props.type}`;
    addDDError(error);
    console.error(error);
    return null;
  }
  const Card = Cards[props.type];
  return <Card {...props} />;
};
